import React from 'react';
import { Check } from 'lucide-react';
import Container from './Container';
import Button from './Button';

const plans = [
  {
    name: 'Starter',
    price: '299',
    description: 'Perfect for small roofing companies',
    features: [
      'AI-Powered Keyword Research',
      'Basic Local SEO Tools',
      'Up to 3 Service Areas',
      'Monthly Performance Reports',
      'Email Support'
    ]
  },
  {
    name: 'Professional',
    price: '599',
    description: 'Best for growing businesses',
    popular: true,
    features: [
      'Everything in Starter, plus:',
      'Advanced GBP Optimization',
      'Up to 10 Service Areas',
      'Competitor Analysis',
      'Priority Support',
      'Weekly Performance Reports'
    ]
  },
  {
    name: 'Enterprise',
    price: '999',
    description: 'For multi-location companies',
    features: [
      'Everything in Professional, plus:',
      'Unlimited Service Areas',
      'Custom Reporting Dashboard',
      'API Access',
      'Dedicated Account Manager',
      'Daily Performance Updates'
    ]
  }
];

const Pricing = () => {
  return (
    <section id="pricing" className="py-20 bg-white">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Choose the perfect plan for your roofing business
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative rounded-2xl p-8 ${
                plan.popular
                  ? 'bg-blue-600 text-white shadow-xl scale-105'
                  : 'bg-white border-2 border-gray-200'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="bg-blue-500 text-white px-4 py-1 rounded-full text-sm font-medium">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <h3 className={`text-2xl font-bold mb-2 ${
                  plan.popular ? 'text-white' : 'text-gray-900'
                }`}>
                  {plan.name}
                </h3>
                <p className={`mb-4 ${
                  plan.popular ? 'text-blue-100' : 'text-gray-600'
                }`}>
                  {plan.description}
                </p>
                <div className="flex items-center justify-center">
                  <span className="text-3xl font-bold">$</span>
                  <span className="text-5xl font-bold mx-1">{plan.price}</span>
                  <span className="text-lg">/mo</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center">
                    <Check className={`h-5 w-5 mr-3 flex-shrink-0 ${
                      plan.popular ? 'text-blue-200' : 'text-blue-600'
                    }`} />
                    <span className={plan.popular ? 'text-blue-100' : 'text-gray-600'}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <Button
                variant={plan.popular ? 'secondary' : 'primary'}
                className="w-full"
              >
                Get Started
              </Button>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            Need a custom plan? Contact our sales team
          </p>
          <Button variant="secondary">
            Contact Sales
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default Pricing;